export const postTasksKeys = {
  all: ['post-tasks'] as const,
  list: (...args: unknown[]) => [...postTasksKeys.all, 'list', ...args] as const,
  item: (id: string) => [...postTasksKeys.all, 'item', id] as const,
};
